<template>
	<div class="ma-4">
		<v-list>
			<v-list-item v-for="(note, index) in object.notes" :key="index">
				<v-list-item-avatar color="primary" dark>
					<span class="white--text">{{getUserAvatar(note.author)}}</span>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title v-text="note.content"></v-list-item-title>
					<span class="overline">	{{ note.created.toDate() | moment("HH:mm D/MM/YYYY") }}</span>
				</v-list-item-content>
				<v-list-item-icon>
					<v-btn @click="deleteNote(index)" icon><v-icon>mdi-close</v-icon></v-btn>
				</v-list-item-icon>
			</v-list-item>
		</v-list>
			<v-textarea v-model="newNote" label="New Note" v-on:keydown.enter="createNote"></v-textarea>
		<v-btn color="green" @click="createNote" dark>Save</v-btn>
	</div>
</template>

<script>
	import Vuex from 'vuex'
	import firebase from "firebase";
	
	export default {
		name: "Object Notes", 
		data: () => {
			return {
				newNote: ''
			}
		}, 
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user, 
				admins: state => state.admin.admins
			})
		},
		props: {
			object: {type: Object} 
		}, 
		methods: {
			getUserAvatar(id){
				let admin = this.admins.find( a => a.id == id )
				if( !admin ){ return ""; }
				return admin.displayName.split(" ").map( a => a.substr(0,1)).join("");
			},
			createNote(){
				
				let now = firebase.firestore.Timestamp.fromDate(new Date());
				let newNote = {
					content: this.newNote, 
					created: now,
					author: this.$store.state.auth.user.uid
				}
				this.object.notes.push(newNote)
				this.$emit("save");
				this.newNote = "";
			},
			deleteNote(i){
				this.object.notes.splice(i, 1);
				this.$emit("save")
			}
		}
	}
</script>